import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useSubmitLoginFormMutation } from "../../../services/RegisterAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import CryptoJS from "crypto-js";
import {
  useTransferCartMutation,
  useGetCartCountQuery,
} from "../../../services/cartPageAPI";

function Registerform() {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const [errors, setErrors] = useState({});

  const { refetch: refetchCartCountData } = useGetCartCountQuery();
  const { data: colorthemeData } = useGetColorThemeQuery();

  const [submitLoginForm, { isLoading }] = useSubmitLoginFormMutation();
  const [transferCartToken] = useTransferCartMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const validateForm = () => {
    const newErrors = {};
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } 

    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const encryptData = (data) => {
    const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
    const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

    if (!key || !iv) {
      console.error("Encryption key or IV is missing!");
      return null;
    }

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  };

  const decryptData = (encryptedData) => {
    try {
      const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
      const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

      if (!key || !iv) {
        console.error("Decryption key or IV is missing!");
        return null;
      }

      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)); // Parse JSON if necessary
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (!validateForm()) {
      return;
    }

    try {

      const EncryptedUserName = encryptData(formData.email);
      const EncryptedPassword = encryptData(formData.password);

      const encryptedData = {
        email:EncryptedUserName,
        password:EncryptedPassword
      }
      const response = await submitLoginForm(encryptedData).unwrap();
      setMessage(response.message);
      if (response.success === true) {
        setMessageType("success");

        localStorage.setItem("access_token", response.access_token);

        const encryptedUser = response.user;
        const decryptedUser = decryptData(encryptedUser);
     
        // userId
        localStorage.setItem("gridMarker", decryptedUser.id);
        // localStorage.setItem("user", JSON.stringify(decryptedUser));
        localStorage.setItem("refresh_token", response.refresh_token);

        const cartToken = localStorage.getItem("cartToken");
        const checkguestCheckout = localStorage.getItem("guestCheckOutEnable");

        if (cartToken) {
          let formData = {
            user_id: response.user.id,
            guest_cart_token: cartToken,
          };
          try {
            const response = await transferCartToken(formData).unwrap();
            refetchCartCountData();
            localStorage.removeItem("cartToken");
            localStorage.removeItem("OrderId");
            localStorage.removeItem("OrderMainId");
            localStorage.removeItem("guestCheckOutEnable");

            localStorage.setItem("cart_id", response.cart_id);
          } catch (error) {
            console.log(error);
          }
          if (checkguestCheckout) {
            const newCartId = localStorage.getItem("cart_id");
            navigate(`/checkout/${newCartId}`);
          } else {
            navigate("/my-account");
          }
        } else {
          setFormData({ email: "", password: "" });
          refetchCartCountData();
          navigate("/my-account");
          localStorage.removeItem("cartToken");
          localStorage.removeItem("OrderId");
          localStorage.removeItem("OrderMainId");
          localStorage.removeItem("cart_id");
          localStorage.removeItem("guestCheckOutEnable");
        }
      } else {
        setMessageType("error");
      }
    } catch (error) {
      setMessage(
        error.data?.message || error.data?.error || "Failed to Login."
      );
      setMessageType("error");
    }
  };

  return (
    <div className="register-form">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12">
            <div className="left-div">
              <h4>Login</h4>
              <form onSubmit={handleSubmit}>
                <div className="mb-20">
                  <label>Username or Email *</label>
                  <br />
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <p className="error-text">{errors.email}</p>}
                </div>

                <div className="mb-20">
                  <div className="relative">
                    <label>Password *</label>
                    <br />
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="absolute show-hide-pasw-btn"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />
                    </button>
                  </div>
                  {errors.password && (
                    <p className="error-text">{errors.password}</p>
                  )}
                </div>
                <div className="text-end">
                  <Link to="/forgot-password">
                    <p className="forgot-password-text">Forgot password</p>
                  </Link>
                </div>
                <p>
                  Your personal data will be used to support your experience
                  throughout this website, to manage access to your account, and
                  for other purposes described in our{" "}
                  <Link to="/privacy-policy"> Privacy policy.</Link>
                </p>
                <button
                  type="submit"
                  className="primary-button w-100"
                  disabled={isLoading}
                  style={{
                    backgroundColor:
                      colorthemeData?.color_themes?.[0]?.primary_color ||
                      "#a76d50",
                  }}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </form>


              {message && (
                <p
                  className={
                    messageType === "success"
                      ? "success-message"
                      : "error-message"
                  }
                >
                  {message}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12">
            <div className="right-div">
              <h4>Register</h4>
              <p>
                Login here by filling you're username and password or use your
                favorite social network account to enter to the site. Site login
                will simplify the purchase process and allows you to manage your
                personal account.
              </p>
              <Link to="/register">
                <button  className="primary-button" style={{
                    backgroundColor:
                      colorthemeData?.color_themes?.[0]?.primary_color ||
                      "#a76d50",
                  }}>Register</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registerform;
